var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayerOneLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 98,
    viewBox: "0 0 139 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6472 4C66.4736 1.79086 72.6773 1.79086 76.5036 4L131.929 36C135.756 38.2091 135.756 41.7909 131.929 44L76.5036 76C72.6773 78.2091 66.4736 78.2091 62.6472 76L7.22161 44C3.39527 41.7909 3.39527 38.2091 7.22161 36L62.6472 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6472 4C66.4736 1.79086 72.6773 1.79086 76.5036 4L131.929 36C135.756 38.2091 135.756 41.7909 131.929 44L76.5036 76C72.6773 78.2091 66.4736 78.2091 62.6472 76L7.22161 44C3.39527 41.7909 3.39527 38.2091 7.22161 36L62.6472 4Z",
    fill: "#6165FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 0.5 0 1 7.22168 44)",
    fill: "#BDACFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.5037 76)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.5037 76)",
    fill: "#8285F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35181 40C4.35181 41.5621 5.44848 42.9763 7.22156 44V64C5.44848 62.9763 4.35181 61.5621 4.35181 60V40Z",
    fill: "#BDACFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6472 76C66.4736 78.2091 72.6773 78.2091 76.5036 76V96C72.6773 98.2091 66.4736 98.2091 62.6472 96V76Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6472 76C66.4736 78.2091 72.6773 78.2091 76.5036 76V96C72.6773 98.2091 66.4736 98.2091 62.6472 96V76Z",
    fill: "#8285F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.799 40C134.799 41.5621 133.702 42.9763 131.929 44V64C133.702 62.9763 134.799 61.5621 134.799 60V40Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.799 40C134.799 41.5621 133.702 42.9763 131.929 44V64C133.702 62.9763 134.799 61.5621 134.799 60V40Z",
    fill: "#8285F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerOneLevel);
export default __webpack_public_path__ + "static/media/layer-one-level.f050516970d90cb6d0af06127a645e64.svg";
export { ForwardRef as ReactComponent };